<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <!-- <div class="float-right">
                    <button class="btn dash-btns mr-3" [routerLink]="['/pos/orders/new']">New Orders </button>
                    <button class="btn dash-btns " [routerLink]="['/pos/orders/manage']">Manage Orders </button>
                </div> -->
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <a class="view-h gary-t">View Orders Details</a>
                                </div>

                                <div>
                                    <div class=" pt-3">
                                        <!-- <div class="row  mb-3">
      
                                        <div class="col-4 p-0"><label> PosSubscription Id</label> </div>
                                         
                                        <div class="col-7 p-0 view-text"> {{PosSubscriptionId}}</div>
                                    </div> -->

                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"><label>  Order Id </label></div>

                                            <div class="col-7 p-0 view-text"> {{OrderId}}</div>
                                        </div>
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"><label> Item Count</label></div>

                                            <div class="col-7 p-0 view-text"> {{LineItemCount}}</div>
                                        </div>
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"> <label> Item Amount</label> </div>

                                            <div class="col-7 p-0 view-text">  {{currency}}{{ItemAmount}}</div>
                                        </div>
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"> <label> Tax Amount</label> </div>

                                            <div class="col-7 p-0 view-text">  {{currency}}{{TaxAmount}}</div>
                                        </div>
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"> <label> Discount Amount</label> </div>

                                            <div class="col-7 p-0 view-text">  {{currency}}{{DiscountAmount}}</div>
                                        </div>
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"><label> Total Amount </label></div>

                                            <div class="col-7 p-0 view-text robot"> {{currency}}{{TotalNetAmount}}</div>
                                        </div>

                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"><label>  Tender Type</label> </div>

                                            <div class="col-7 p-0 view-text"> {{TenderType}}</div>
                                        </div>

                                        <div class="row  mb-3" *ngIf="cashtransactiondetails">

                                            <div class="col-4 p-0"> <label> Tender Amount</label> </div>

                                            <div class="col-7 p-0 view-text">{{tenderAmount}}</div>
                                        </div>
                                        <div class="row  mb-3" *ngIf="cashtransactiondetails">

                                            <div class="col-4 p-0"> <label> Return Amount</label> </div>

                                            <div class="col-7 p-0 view-text">{{ReturnAmount}}</div>
                                        </div>
                                     
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"> <label> Shipping Amount</label> </div>

                                            <div class="col-7 p-0 view-text"> {{ShippingAmount}}</div>
                                        </div>
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"><label>  Tip Amount</label> </div>

                                            <div class="col-7 p-0 view-text"> {{TipAmount}}</div>
                                        </div>
                                      
                                        <!-- <div class="row  mb-3">
      
                                        <div class="col-4 p-0"> <label> Order Source </label></div>
                                         
                                        <div class="col-7 p-0 view-text">{{OrderSource}}</div>
                                    </div> -->
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"> <label> Order Status</label> </div>

                                            <div class="col-7 p-0 view-text">{{OrderStatus}}</div>
                                        </div>
                                        <div class="row  mb-3" *ngIf="PaymentStatusinfo">

                                            <div class="col-4 p-0"><label> Payment Status </label></div>

                                            <div class="col-7 p-0 view-text">{{PaymentStatus}}</div>
                                        </div>
                                        <div class="row  mb-3" *ngIf="transactiondetails">

                                            <div class="col-4 p-0"> <label> Transaction Id</label> </div>

                                            <div class="col-7 p-0 view-text">{{PaymentId}}
                                                <a class="view"
                                                    [routerLink]="['/pos/transactiondetails',{id : PaymentId,batchId : row,paymentType:TenderType}] "
                                                    data-toggle="tooltip" data-placement="top" title="View">
                                                    <img src="./assets/ViewDetails.svg"></a>

                                            </div>



                                        </div>

                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"> <label> Customer Name</label> </div>

                                            <div class="col-7 p-0 view-text">{{Customername}}</div>
                                        </div>
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"><label> Customer Email</label> </div>

                                            <div class="col-7 p-0 view-text">{{CustomerEmail}}</div>
                                        </div>
                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"><label> Customer Mobile</label> </div>

                                            <div class="col-7 p-0 view-text">{{Customermobile}}</div>
                                        </div>


                                        <div class="row  mb-3">

                                            <div class="col-4 p-0"><label> Order Source</label> </div>

                                            <div class="col-7 p-0 view-text"> {{OrderSource}}</div>
                                        </div>

                                        <!-- <div class="d-inline ml-1" fxFlex="25%" fxLayout.gt-md="row"
                                            *ngIf="printoption">
                                            <button class="btn btn-primary" style="float:right" color="primary"
                                                id="btnDownload" (click)="DownLoadPage()"
                                                matTooltip="Download response page"><i
                                                    class="fas fa-print"></i></button>
                                        </div> -->
                                        <!-- <div class="row  mb-3" *ngIf="paymenturl">

                                            <div class="col-4 p-0"><label> Payment Process Url</label> </div>

                                            <div class="col-8 p-0 view-text">{{PaymentProcessUrl}}
                                            </div>
                                           
                                        </div> -->
                                        <div class="row mb-3">
                                            <div class="col-md-8 p-0">
                                              <div class="form-group">
                                                <input type="code" class="formcontrol-user form-control" value="code"
                                                  [(ngModel)]="PaymentProcessUrl" readonly #sharableLink />
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <button (click)="copyToClipboard(sharableLink)" id="btncopylink" class="btn dash-btns mr-3"
                                                color="primary" fxFlex="20">Copy link</button>
                                            </div>
                                          </div>
                                        <div class="text-right py-2">
                                            <button  class="btn dash-btns mr-3" (click)="generateEBill()" id="btnebilllink" 
                                            fxFlex="20">Generate E-Way Bill</button>
                                            <button class="btn dash-btns mr-3" [routerLink]="['/pos/orders/new']">New Orders </button>
                                            <button class="btn dash-btns mr-3 " [routerLink]="['/pos/orders/manage']">Back</button>  
                                          <span *ngIf="printoption">
                                            <button  class="btn btn-primary" style="float:right" color="primary"
                                            id="btnDownload" (click)="DownLoadPage()"
                                            matTooltip="Download response page"><i
                                                class="fas fa-print"></i></button>
                                          </span> 
                                        </div>
                                        <!-- <div class="d-inline ml-1" fxFlex="25%" fxLayout.gt-md="row"
                                        *ngIf="printoption">
                                        <button class="btn btn-primary" style="float:right" color="primary"
                                            id="btnDownload" (click)="DownLoadPage()"
                                            matTooltip="Download response page"><i
                                                class="fas fa-print"></i></button>
                                    </div> -->

                                        <!-- <div class="row  mb-3">
      
                                                          <div class="col-4 p-0"><label> Customer Addresss</label> </div>
                                                           
                                                          <div class="col-7 p-0 view-text">{{CustomerAddresss}}</div>
                                                      </div> -->



                                    </div>
                                    <!-- <div class="text-right pt-3">
                                        <button class="damke_siteBtn" type="button" id="accountsList" [routerLink]="['/pos/orders/manage']">Back</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-4">
                    <div>
                        <ngx-datatable #table class='bootstrap no-detail-row' [scrollbarH]="true" (columnMode)="'Force'"
                            [footerHeight]="50" [rowHeight]="'auto'"[columnMode]="'force'" [limit]="10" [rows]="rows" >

                            <!-- <ngx-datatable-column name="Item Id">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.ItemId}} </ng-template>
                            </ngx-datatable-column> -->
                            <ngx-datatable-column name="Item Description" [width]="300">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.itemDescription}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Item Name" [width]="300">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.itemName}} </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Item Category" [width]="300">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.itemCategory}}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Quantity" [width]="195">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.quantity}} </ng-template>

                            </ngx-datatable-column>
                            <ngx-datatable-column name="Item Price" [width]="195">

                                <ng-template let-row="row" ngx-datatable-cell-template>{{currency}} {{row.itemPrice | number : '1.2-2'}} </ng-template>
                            </ngx-datatable-column>

                            <!-- <ngx-datatable-column name="Tax Rate">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.taxrate}}%
                                </ng-template>
                            </ngx-datatable-column> -->
                            <ngx-datatable-column name="Tax Amount">
                                <ng-template let-row="row" ngx-datatable-cell-template>{{currency}} {{row.taxamount | number : '1.2-2'}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Item Amount">
                                <ng-template let-row="row" ngx-datatable-cell-template>{{currency}} {{row.ItemAmount | number : '1.2-2'}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Product Code">
                                <ng-template let-row="row" ngx-datatable-cell-template> {{row.ProductCode}}
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>